export const headers = [
  {
    key: "device",
    align: "left",
    name: "Device Name",
  },
  {
    key: "date",
    align: "left",
    name: "Date",
  },
  {
    key: "time",
    align: "left",
    name: "Time",
  },
  {
    key: "ip",
    align: "left",
    name: "IP",
  },
  {
    key: "type",
    align: "left",
    name: "Type",
  },
];
